import React from 'react';
import { Formik, Form } from 'formik';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import CustomJobMatchingForm from './CustomJobMatchingForm';
import StandardJobMatchForm from './StandardJobMatchForm';
import { CUSTOM_JOB_MATCH_TYPE, STANDARD_JOB_MATCH_TYPE } from '../../../../shared/Constants';

const JobMatch = ({
  jobMatchType,
  currentLanguage,
  assessmentId,
  onLoadMatchingResult,
  onLoadStandardMatchingResult,
  searchStandardJob,
  searching,
  jobProfiles,
  standardJobProfiles,
  selectJobMatching,
  selectStandardJobMatching,
  selectPreferredLanguage,
  changePrinterFriendly,
  printerFriendlyReports,
  selectedJobId,
  selectedStandardJob,
}) => {
  const { translatedTags: languageList } = useSelector((state) => state.i18n);

  if (jobMatchType === CUSTOM_JOB_MATCH_TYPE) {
    const initialValues = {
      locale: currentLanguage,
      assessmentId,
      jobProfileId: selectedJobId,
    };

    return (
      <Formik
        enableReinitialize
        initialValues={initialValues}
        onSubmit={async (value, { setSubmitting }) => {
          onLoadMatchingResult(value);
          setSubmitting(false);
        }}
      >
        <Form>
          <CustomJobMatchingForm
            jobProfiles={jobProfiles}
            selectJob={selectJobMatching}
            languageList={languageList}
            selectLocale={selectPreferredLanguage}
            changePrinterFriendly={changePrinterFriendly}
            printerFriendly={printerFriendlyReports}
            readyToSubmit={selectedJobId}
          />
        </Form>
      </Formik>
    );
  }

  if (jobMatchType === STANDARD_JOB_MATCH_TYPE) {
    const initialValues = {
      locale: currentLanguage,
      assessmentId,
    };

    return (
      <Formik
        initialValues={initialValues}
        onSubmit={async (value, { setSubmitting }) => {
          onLoadStandardMatchingResult(value);
          setSubmitting(false);
        }}
      >
        <Form>
          <StandardJobMatchForm
            searchJob={searchStandardJob}
            jobSearching={searching}
            jobProfiles={standardJobProfiles}
            selectJob={selectStandardJobMatching}
            languageList={languageList}
            selectLocale={selectPreferredLanguage}
            readyToSubmit={selectedStandardJob}
          />
        </Form>
      </Formik>
    );
  }

  return <></>;
};

JobMatch.propTypes = {
  jobMatchType: PropTypes.string.isRequired,
  currentLanguage: PropTypes.string.isRequired,
  assessmentId: PropTypes.string.isRequired,
  onLoadMatchingResult: PropTypes.func.isRequired,
  onLoadStandardMatchingResult: PropTypes.func.isRequired,
  searching: PropTypes.bool.isRequired,
  jobProfiles: PropTypes.arrayOf(PropTypes.any).isRequired,
  standardJobProfiles: PropTypes.arrayOf(PropTypes.any).isRequired,
  searchStandardJob: PropTypes.func.isRequired,
  selectJobMatching: PropTypes.func.isRequired,
  selectStandardJobMatching: PropTypes.func.isRequired,
  selectPreferredLanguage: PropTypes.func.isRequired,
  changePrinterFriendly: PropTypes.func.isRequired,
  printerFriendlyReports: PropTypes.bool.isRequired,
  selectedJobId: PropTypes.string.isRequired,
  selectedStandardJob: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default JobMatch;
